import { render } from "./Supplier_responsibles.vue?vue&type=template&id=5cc4165b"
import script from "./Supplier_responsibles.vue?vue&type=script&lang=js"
export * from "./Supplier_responsibles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__